import { isMobile } from '../services/wix-sdk-utils';
import { hideModal } from './hide-modal';
import { closeWixModal } from './close-wix-modal';
import { isInWix } from '../services/is-in-wix';

export const closeModal = payload => dispatch => {
  let action = hideModal(payload);

  if (!isMobile() && isInWix()) {
    action = closeWixModal(action);
  }

  dispatch(action);
};



// WEBPACK FOOTER //
// ./app/actions/close-modal.js